import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const environments = [
  "Industrial project environments",
  "Construction and infrastructure sites",
  "Technical installation environments",
  "Work-at-height project support",
  "Subcontracted project team experience",
];

const projectWork = [
  "Rope access work in industrial and technical settings",
  "Technical support for contractors and subcontracted teams",
  "Work carried out under agreed project procedures",
  "Support in demanding work-at-height conditions",
];

const Experience = () => {
  return (
    <section id="experience" className="section-spacing experience-section">
      <Container>
        <Row className="align-items-start g-5">
          <Col lg={5}>
            <p className="section-kicker">Experience</p>
            <h2 className="section-title">Project-Site Experience Across Europe</h2>
            <p className="lead section-lead">
              SUPPoland's experience includes work performed as part of
              subcontracted project teams on industrial, construction, and
              technical sites across Europe.
            </p>
            <p>
              This includes practical experience in large-scale facilities,
              technical installations, infrastructure-related works, and demanding
              work-at-height conditions.
            </p>
            <p className="mb-0">
              The focus is practical: rope access, technical support, disciplined
              site cooperation, and work carried out under agreed project
              procedures.
            </p>
          </Col>
          <Col lg={7}>
            <Row className="g-3 mb-4">
              {environments.map((environment) => (
                <Col sm={6} key={environment}>
                  <div className="experience-pill">{environment}</div>
                </Col>
              ))}
            </Row>
            <div className="info-card project-work-card">
              <p className="card-eyebrow">Typical project involvement</p>
              <ul className="clean-list mb-0">
                {projectWork.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Experience;